import { render, staticRenderFns } from "./StudentMonitorScores.vue?vue&type=template&id=4476c7e6&scoped=true"
import script from "./StudentMonitorScores.vue?vue&type=script&lang=js"
export * from "./StudentMonitorScores.vue?vue&type=script&lang=js"
import style0 from "./StudentMonitorScores.vue?vue&type=style&index=0&id=4476c7e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4476c7e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSlideYTransition } from 'vuetify/lib/components/transitions';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDatePicker,VIcon,VMenu,VSlideYTransition,VTextField})
